import React, { useState, useEffect, useCallback } from 'react';
import { Form, Row, Table, Pagination, Button } from "react-bootstrap";
// Removed unused RiMenu2Line import
import * as XLSX from 'xlsx';
import "./Admin.css";

function Alllist() {

    const [entries, setEntries] = useState([]);
    const [loading, setLoading] = useState(true);

    const [selectedDistrict, setSelectedDistrict] = useState('');
    const [selectedTaluk, setSelectedTaluk] = useState('');
    const [selectedVillage, setSelectedVillage] = useState('');
    const [selectedBranch, setSelectedBranch] = useState('');
    
    // Removed unused setters
    const [searchQuery] = useState(''); 

    const [districts, setDistricts] = useState([]);
    const [taluks, setTaluks] = useState([]);
    const [villages, setVillages] = useState([]);
    const [branches, setBranches] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [totalEntries, setTotalEntries] = useState(0);
    
    // Removed unused setters
    const [perPage] = useState(30);

    const [selectedCategory, setSelectedCategory] = useState("");
    const [selectedRows, setSelectedRows] = useState([]);

    // Specific Filters
    const [karaFilter, setKaraFilter] = useState('');
    const [oldTpFilter, setOldTpFilter] = useState('');
    const [oldSyNoFilter, setOldSyNoFilter] = useState('');
    const [subDivNoFilter, setSubDivNoFilter] = useState('');
    const [reSyBkNoFilter, setReSyBkNoFilter] = useState('');
    const [reSyNoFilter, setReSyNoFilter] = useState('');
    const [eastFilter, setEastFilter] = useState('');
    const [westFilter, setWestFilter] = useState('');
    const [northFilter, setNorthFilter] = useState('');
    const [southFilter, setSouthFilter] = useState('');

    // Wrap fetchData in useCallback to fix useEffect dependency warning
    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const requestBody = {
                page: currentPage,
                branch_id: selectedBranch || undefined,
                district_id: selectedDistrict || undefined,
                taluk_id: selectedTaluk || undefined,
                village_id: selectedVillage || undefined,
                schedule_number: undefined,
                search: searchQuery || "",
                per_page: perPage,
                kara: karaFilter || undefined,
                old_tp: oldTpFilter || undefined,
                old_sy_no: oldSyNoFilter || undefined,
                sub_division_number: subDivNoFilter || undefined,
                re_sy_bk_no: reSyBkNoFilter || undefined,
                re_sy_no: reSyNoFilter || undefined,
                east: eastFilter || undefined,
                west: westFilter || undefined,
                north: northFilter || undefined,
                south: southFilter || undefined,
            };

            const response = await fetch('https://paalyam.jinskadamthodu.com/api/public/land-entry/search', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(requestBody),
            });

            if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
            const data = await response.json();

            if (data?.data && Array.isArray(data.data)) {
                setEntries(data.data);
                setLastPage(data.pagination?.last_page || 1);
                setTotalEntries(data.pagination?.total_records || 0);
            } else {
                setEntries([]);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }, [currentPage, selectedBranch, selectedDistrict, selectedTaluk, selectedVillage, searchQuery, perPage, karaFilter, oldTpFilter, oldSyNoFilter, subDivNoFilter, reSyBkNoFilter, reSyNoFilter, eastFilter, westFilter, northFilter, southFilter]);

    useEffect(() => {
        fetchData();
    }, [fetchData]); // Added fetchData to dependency array

    useEffect(() => {
        const fetchDropdownData = async () => {
            try {
                const branchesResponse = await fetch('https://paalyam.jinskadamthodu.com/api/public/branch');
                const branchesData = await branchesResponse.json();
                setBranches(branchesData);

                const villagesResponse = await fetch('https://paalyam.jinskadamthodu.com/api/public/village');
                const villagesData = await villagesResponse.json();

                const uniqueDistricts = [...new Set(villagesData.map((item) => item.district_name))].map((districtName) => {
                    const district = villagesData.find((item) => item.district_name === districtName);
                    return { id: district.district_id, name: district.district_name };
                });
                setDistricts(uniqueDistricts);
            } catch (error) {}
        };
        fetchDropdownData();
    }, []);

    const handleDistrictChange = async (e) => {
        const districtId = e.target.value;
        setSelectedDistrict(districtId);
        setSelectedTaluk('');
        setSelectedVillage('');
        try {
            const response = await fetch(`https://paalyam.jinskadamthodu.com/api/public/taluk`);
            const data = await response.json();
            // Fixed equality check to strict (===) and converted to String for safety
            const filteredTaluks = data.filter(taluk => String(taluk.district_id) === String(districtId)).map(taluk => ({ id: taluk.taluk_id, name: taluk.taluk_name }));
            setTaluks(filteredTaluks);
        } catch (error) {}
    };

    const handleTalukChange = async (e) => {
        const talukId = e.target.value;
        setSelectedTaluk(talukId);
        setSelectedVillage('');
        try {
            const response = await fetch(`https://paalyam.jinskadamthodu.com/api/public/village`);
            const data = await response.json();
             // Fixed equality check to strict (===) and converted to String for safety
            const filteredVillages = data.filter(village => String(village.taluk_id) === String(talukId)).map(village => ({ id: village.village_id, name: village.village_name }));
            setVillages(filteredVillages);
        } catch (error) {}
    };

    const handleBranchChange = (e) => setSelectedBranch(e.target.value);
    const handleVillageChange = (e) => setSelectedVillage(e.target.value);
    const handlePageChange = (page) => setCurrentPage(page);

    const handleKaraFilterChange = (e) => setKaraFilter(e.target.value);
    const handleOldTpFilterChange = (e) => setOldTpFilter(e.target.value);
    const handleOldSyNoFilterChange = (e) => setOldSyNoFilter(e.target.value);
    const handleSubDivNoFilterChange = (e) => setSubDivNoFilter(e.target.value);
    const handleReSyBkNoFilterChange = (e) => setReSyBkNoFilter(e.target.value);
    const handleReSyNoFilterChange = (e) => setReSyNoFilter(e.target.value);
    const handleEastFilterChange = (e) => setEastFilter(e.target.value);
    const handleWestFilterChange = (e) => setWestFilter(e.target.value);
    const handleNorthFilterChange = (e) => setNorthFilter(e.target.value);
    const handleSouthFilterChange = (e) => setSouthFilter(e.target.value);

    // Fetch All Data for Export (Including Filters)
    const fetchAllData = async () => {
        try {
            const requestBody = {
                branch_id: selectedBranch || undefined,
                district_id: selectedDistrict || undefined,
                taluk_id: selectedTaluk || undefined,
                village_id: selectedVillage || undefined,
                schedule_number: undefined,
                search: searchQuery || "",
                per_page: 10000,
                kara: karaFilter || undefined,
                old_tp: oldTpFilter || undefined,
                old_sy_no: oldSyNoFilter || undefined,
                sub_division_number: subDivNoFilter || undefined,
                re_sy_bk_no: reSyBkNoFilter || undefined,
                re_sy_no: reSyNoFilter || undefined,
                east: eastFilter || undefined,
                west: westFilter || undefined,
                north: northFilter || undefined,
                south: southFilter || undefined,
            };

            const response = await fetch('https://paalyam.jinskadamthodu.com/api/public/land-entry/search', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(requestBody),
            });

            if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
            const data = await response.json();
            return data.data || [];
        } catch (error) {
            return [];
        }
    };

    const exportToExcel = (data, fileName = "Exported_Data", sheetName = "Sheet1") => {
        if (!Array.isArray(data) || data.length === 0) {
            alert("No data available to export.");
            return;
        }

        const flattenedData = data.map(entry => ({
            serial_number: entry.serial_number || '-',
            branch: entry.branch?.branch_name || '-',
            schedule_number: entry.schedule_number || '-',
            district: entry.district?.district_name || '-',
            taluk: entry.taluk?.taluk_name || '-',
            village: entry.village?.village_name || '-',
            kara: entry.kara || '-',
            old_tp: entry.old_tp || '-',
            old_sy_no: entry.old_sy_no || '-',
            sub_division_number: entry.sub_division_number || '-',
            acre: entry.acre || '-',
            cents: entry.cents || '-',
            re_sy_bk_no: entry.re_sy_bk_no || '-',
            re_sy_no: entry.re_sy_no || '-',
            sub_div: entry.sub_div || '-',
            hector: entry.hector || '-',
            areas: entry.areas || '-',
            square_meter: entry.square_meter || '-',
            east: entry.east || '-',
            west: entry.west || '-',
            north: entry.north || '-',
            south: entry.south || '-',
        }));
        
        const worksheet = XLSX.utils.json_to_sheet(flattenedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
        XLSX.writeFile(workbook, `${fileName}.xlsx`);
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            const allRowIds = entries.map((entry) => entry.id);
            setSelectedRows(allRowIds);
        } else {
            setSelectedRows([]);
        }
    };

    const handleRowSelect = (id) => {
        if (selectedRows.includes(id)) {
            setSelectedRows(selectedRows.filter((rowId) => rowId !== id));
        } else {
            setSelectedRows([...selectedRows, id]);
        }
    };

    const handleClearFilters = () => {
        setSelectedBranch("");
        setSelectedDistrict("");
        setSelectedTaluk("");
        setSelectedVillage("");
        setSelectedCategory("");
        setKaraFilter("");
        setOldTpFilter("");
        setOldSyNoFilter("");
        setSubDivNoFilter("");
        setReSyBkNoFilter("");
        setReSyNoFilter("");
        setEastFilter("");
        setWestFilter("");
        setNorthFilter("");
        setSouthFilter("");
    };

    return (
        <div className="admin-container">
            <div className="admin-sidebar">
                <div className="sidebar-heading">
                    <h2>List Filter</h2>
                    <div className="sidebar-form-filter">
                        <Form>
                            <Row>
                                <Form.Group className="mb-3">
                                    <Form.Select onChange={handleBranchChange} value={selectedBranch}>
                                        <option value="">Filter Branch</option>
                                        {branches.map((branch) => <option key={branch.id} value={branch.id}>{branch.branch_name}</option>)}
                                    </Form.Select>
                                </Form.Group>
                            </Row>
                            <Row>
                                <Form.Group className="mb-3">
                                    <Form.Select onChange={handleDistrictChange} value={selectedDistrict}>
                                        <option value="">Filter District</option>
                                        {districts.map((district) => <option key={district.id} value={district.id}>{district.name}</option>)}
                                    </Form.Select>
                                </Form.Group>
                            </Row>
                            <Row>
                                <Form.Group className="mb-3">
                                    <Form.Select onChange={handleTalukChange} value={selectedTaluk} disabled={!selectedDistrict}>
                                        <option value="">Filter Taluk</option>
                                        {taluks.map((taluk) => <option key={taluk.id} value={taluk.id}>{taluk.name}</option>)}
                                    </Form.Select>
                                </Form.Group>
                            </Row>
                            <Row>
                                <Form.Group className="mb-3">
                                    <Form.Select onChange={handleVillageChange} value={selectedVillage} disabled={!selectedTaluk}>
                                        <option value="">Filter Village</option>
                                        {villages.map((village) => <option key={village.id} value={village.id}>{village.name}</option>)}
                                    </Form.Select>
                                </Form.Group>
                            </Row>
                            
                             <Row>
                                <Form.Group className="mb-3">
                                    <Form.Control type="text" placeholder="Filter Kara" value={karaFilter} onChange={handleKaraFilterChange} />
                                </Form.Group>
                            </Row>

                            <Row className="mb-3">
                                <Form.Group>
                                    <Form.Select onChange={(e) => setSelectedCategory(e.target.value)} value={selectedCategory}>
                                        <option value="">Select Category</option>
                                        <option value="oldSurvey">Old Survey No.</option>
                                        <option value="reSurvey">Re Survey No.</option>
                                        <option value="byBoundaries">By Boundaries</option>
                                    </Form.Select>
                                </Form.Group>
                            </Row>

                            {selectedCategory === "oldSurvey" && (
                                <Row className="mb-3">
                                    <Form.Group className="mb-3">
                                        <Form.Label>Old Survey</Form.Label>
                                        <Form.Control type="text" placeholder="Enter Old Tp" value={oldTpFilter} onChange={handleOldTpFilterChange}/>
                                    </Form.Group >
                                    <Form.Group className="mb-3">
                                        <Form.Control type="text" placeholder="Enter Old Survey Sy No." value={oldSyNoFilter} onChange={handleOldSyNoFilterChange}/>
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Control type="text" placeholder="Enter Sub Div No." value={subDivNoFilter} onChange={handleSubDivNoFilterChange}/>
                                    </Form.Group>
                                </Row>
                            )}

                            {selectedCategory === "reSurvey" && (
                                <Row className="mb-3">
                                    <Form.Group className="mb-3">
                                        <Form.Label>Re Survey No.</Form.Label>
                                        <Form.Control type="text" placeholder="Enter Block No." value={reSyBkNoFilter} onChange={handleReSyBkNoFilterChange}/>
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Control type="text" placeholder="Enter Re Survey TP." value={reSyNoFilter} onChange={handleReSyNoFilterChange}/>
                                    </Form.Group>
                                </Row>
                            )}

                            {selectedCategory === "byBoundaries" && (
                                <Row className="mb-3">
                                    <Form.Group className="mb-3">
                                        <Form.Label>By Boundries</Form.Label>
                                        <Form.Control type="text" placeholder="Enter East" value={eastFilter} onChange={handleEastFilterChange}/>
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Control type="text" placeholder="Enter West" value={westFilter} onChange={handleWestFilterChange}/>
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Control type="text" placeholder="Enter North" value={northFilter} onChange={handleNorthFilterChange}/>
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Control type="text" placeholder="Enter South" value={southFilter} onChange={handleSouthFilterChange}/>
                                    </Form.Group>
                                </Row>
                            )}

                            <Row >
                                <Button className='filter-clear-btn' onClick={handleClearFilters} style={{ width: '100%' }}>Clear Filters</Button>
                            </Row>
                        </Form>
                    </div>
                </div>
            </div>

            <div className="admin-table">
                <div className="admin-header">
                    <div className="left-header">
                        <div className="admin-total-entries">
                            <p>Total Entries: {totalEntries}</p>
                        </div>
                    </div>

                    <div className="admin-excel-bulkdelete">
                        <Button className='excel' onClick={async () => {
                            const allData = await fetchAllData();
                            exportToExcel(allData, "All_Data", "All Data");
                        }}>
                            Export Filtered Excel Sheet
                        </Button>
                    </div>
                </div>
                {loading ? <p>Loading Data.....</p> : (
                    <div className="table-container">
                        <Table bordered className='table-design'>
                            <thead className='table-heading'>
                                <tr>
                                    <th><input type="checkbox" checked={selectedRows.length === entries.length && entries.length > 0} onChange={handleSelectAll} /></th>
                                    <th>Sl No.</th>
                                    <th>Branch</th>
                                    <th>Schedule No.</th>
                                    <th>District</th>
                                    <th>Taluk</th>
                                    <th>Village</th>
                                    <th>Kara</th>
                                    <th>Old Tp</th>
                                    <th>Old SY No.</th>
                                    <th>Sub Div No.</th>
                                    <th>Acre</th>
                                    <th>Cents</th>
                                    <th>Re Sy Bk No.</th>
                                    <th>Re Sy No.</th>
                                    <th>Sub Div</th>
                                    <th>Hector</th>
                                    <th>Areas</th>
                                    <th>Square Meter</th>
                                    <th>East</th>
                                    <th>South</th>
                                    <th>West</th>
                                    <th>North</th>
                                </tr>
                            </thead>
                            <tbody className='table-body'>
                                {entries.length > 0 ? entries.map((entry) => (
                                    <tr key={entry.id}>
                                        <td><input type="checkbox" checked={selectedRows.includes(entry.id)} onChange={() => handleRowSelect(entry.id)} /></td>
                                        <td>{entry.serial_number || '-'}</td>
                                        <td>{entry.branch?.branch_name || '-'}</td> 
                                        <td>{entry.schedule_number || '-'}</td>
                                        <td>{entry.district?.district_name || '-'}</td> 
                                        <td>{entry.taluk?.taluk_name || '-'}</td> 
                                        <td>{entry.village?.village_name || '-'}</td> 
                                        <td>{entry.kara}</td>
                                        <td>{entry.old_tp}</td>
                                        <td>{entry.old_sy_no}</td>
                                        <td>{entry.sub_division_number}</td>
                                        <td>{entry.acre}</td>
                                        <td>{entry.cents}</td>
                                        <td>{entry.re_sy_bk_no || '-'}</td>
                                        <td>{entry.re_sy_no || '-'}</td>
                                        <td>{entry.sub_div || '-'}</td>
                                        <td>{entry.hector || '-'}</td>
                                        <td>{entry.areas || '-'}</td>
                                        <td>{entry.square_meter || '-'}</td>
                                        <td>{entry.east}</td>
                                        <td>{entry.south}</td>
                                        <td>{entry.west}</td>
                                        <td>{entry.north}</td>
                                    </tr>
                                )) : <tr><td colSpan="23">No data found</td></tr>}
                            </tbody>
                        </Table>
                        <Pagination>
                            <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Previous</Pagination.Prev>
                            <Pagination.Item key={1} active={1 === currentPage} onClick={() => handlePageChange(1)}>1</Pagination.Item>
                            {currentPage > 3 && <Pagination.Ellipsis />}
                            {currentPage > 2 && currentPage < lastPage - 1 && (
                                <>
                                    <Pagination.Item key={currentPage - 1} onClick={() => handlePageChange(currentPage - 1)}>{currentPage - 1}</Pagination.Item>
                                    <Pagination.Item key={currentPage} active onClick={() => handlePageChange(currentPage)}>{currentPage}</Pagination.Item>
                                    <Pagination.Item key={currentPage + 1} onClick={() => handlePageChange(currentPage + 1)}>{currentPage + 1}</Pagination.Item>
                                </>
                            )}
                            {currentPage < lastPage - 2 && <Pagination.Ellipsis />}
                            {lastPage > 1 && <Pagination.Item key={lastPage} active={lastPage === currentPage} onClick={() => handlePageChange(lastPage)}>{lastPage}</Pagination.Item>}
                            <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === lastPage}>Next</Pagination.Next>
                        </Pagination>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Alllist;